/**
 * The order id as GA expects it: a number.
 *
 * Route and query params arrive as text, and several screens stringified the id
 * again on the way into an event, so the same order was reported as `677074` on
 * one page and `"677074"` on the next — two different values to GA.
 *
 * Anything that is not a positive number becomes `undefined`, which the event
 * layer drops: a missing dimension is honest, `0` from an empty param is not.
 */
export var toOrderId = function toOrderId(value) {
  var parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};